import { render, staticRenderFns } from "./Portafolio.vue?vue&type=template&id=c3caa52e&scoped=true"
import script from "./Portafolio.vue?vue&type=script&lang=js"
export * from "./Portafolio.vue?vue&type=script&lang=js"
import style0 from "./Portafolio.vue?vue&type=style&index=0&id=c3caa52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3caa52e",
  null
  
)

export default component.exports